/*!

=========================================================
* Material Dashboard React - v1.8.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import Dashboard from '@material-ui/icons/Dashboard';
import Person from '@material-ui/icons/Person';
// import LibraryBooks from '@material-ui/icons/LibraryBooks';
// import BubbleChart from '@material-ui/icons/BubbleChart';
// import LocationOn from '@material-ui/icons/LocationOn';
// import Notifications from '@material-ui/icons/Notifications';
// import Unarchive from '@material-ui/icons/Unarchive';
import ShowChart from '@material-ui/icons/ShowChart';
// import Language from '@material-ui/icons/Language';

// core components/views for Admin layout
import DashboardPage from './views/Dashboard/Dashboard';
import UserProfile from './views/UserProfile/UserProfile';
import InvestmentsPage from './views/InvestmentsPage/InvestmentsPage';
// import Typography from './views/Typography/Typography';
// import Icons from './views/Icons/Icons';
// import Maps from './views/Maps/Maps';
// import NotificationsPage from './views/Notifications/Notifications';
// import UpgradeToPro from './views/UpgradeToPro/UpgradeToPro';
// core components/views for RTL layout
// import RTLPage from './views/RTLPage/RTLPage';

const dashboardRoutes = [
  {
    path: '/home',
    name: 'Dashboard',
    // rtlName: 'لوحة القيادة',
    icon: Dashboard,
    component: DashboardPage,
    layout: '/dashboard',
  },
  {
    path: '/user',
    name: 'Profile',
    // rtlName: 'ملف تعريفي للمستخدم',
    icon: Person,
    component: UserProfile,
    layout: '/dashboard',
  },
  {
    path: '/investments',
    name: 'Investments',
    // rtlName: 'قائمة الجدول',
    icon: ShowChart,
    component: InvestmentsPage,
    layout: '/dashboard',
  },
  // {
  //   path: '/table',
  //   name: 'Table List',
  //   // rtlName: 'قائمة الجدول',
  //   icon: 'content_paste',
  //   component: TableList,
  //   layout: '/dashboard',
  // },
  // {
  //   path: '/typography',
  //   name: 'Typography',
  //   // rtlName: 'طباعة',
  //   icon: LibraryBooks,
  //   component: Typography,
  //   layout: '/dashboard',
  // },
  // {
  //   path: '/icons',
  //   name: 'Icons',
  //   // rtlName: 'الرموز',
  //   icon: BubbleChart,
  //   component: Icons,
  //   layout: '/dashboard',
  // },
  // {
  //   path: '/maps',
  //   name: 'Maps',
  //   // rtlName: 'خرائط',
  //   icon: LocationOn,
  //   component: Maps,
  //   layout: '/dashboard',
  // },
  // {
  //   path: '/notifications',
  //   name: 'Notifications',
  //   // rtlName: 'إخطارات',
  //   icon: Notifications,
  //   component: NotificationsPage,
  //   layout: '/dashboard',
  // },
  // {
  //   path: '/upgrade-to-pro',
  //   name: 'Upgrade To PRO',
  //   // rtlName: 'التطور للاحترافية',
  //   icon: Unarchive,
  //   component: UpgradeToPro,
  //   layout: '/dashboard',
  // },
];

export default dashboardRoutes;
